import { authRoles } from '@ameroservices-platform/loppe-backend/app/auth';
import Login from './Login';

const LoginConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: false,
				},
				rightSidePanel: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: 'login',
			element: <Login />,
		},
	],
};

export default LoginConfig;
